export const markerIconActive = {
  path: 'M -1 -1 L 1 -1 L 1 1 L -1 1 z',
  strokeColor: '#FFFF00',
  strokeOpacity: 1,
  fillColor: '#FFAA00',
  fillOpacity: 1,
  scale: 4
}
